import {  
    distanceBetweenDots, 
    distanseBetweenLayers, 
    dotDiametr, 
    getCenteredCoordinateForAnimation, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot,
    parabolic,
    MINI_BOUNCE_ANIMATION_TIME,
    JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME
 } from '../../initials';
export class JumpFromDotToDotWithMiniBounceCenterTopRight {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'JumpFromDotToDotWithMiniBounceCenterTopRight',
            fromBallPositionByDot: BallPositionByDot.CENTER,
            toBallPositionByDot: BallPositionByDot.TOP_RIGHT,
        };
    }

    getAnimationTime() {
        return MINI_BOUNCE_ANIMATION_TIME + JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME;
    }

    animate(time) {

        const isLeftMovement = this.fromDotIndex >= this.toDotIndex;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getCenteredCoordinateForAnimation(startDot.dotX, startDot.dotY);
        const endXY = getNotCenteredCoordinateForAnimationByAngle(endDot.dotX, endDot.dotY, Math.PI / 4);

        const firstPartStartX = getCenteredCoordinateForAnimation(startDot.dotX, startDot.dotY);
        const firstPartEndX = isLeftMovement ? firstPartStartX.x - dotDiametr * 0.5 : firstPartStartX.x + dotDiametr * 0.5;

        if (time < MINI_BOUNCE_ANIMATION_TIME) {
            const t = time / MINI_BOUNCE_ANIMATION_TIME;

            return {
                x: parabolic(
                    startXY.x,
                    isLeftMovement ? startXY.x - dotDiametr * 0.25 : startXY.x + dotDiametr * 0.25,
                    firstPartEndX,
                    t
                ),
                y: parabolic(
                    startXY.y,
                    startXY.y - distanseBetweenLayers / 4,
                    startXY.y,
                    t
                )
            };
        }

        const t = (time - MINI_BOUNCE_ANIMATION_TIME) / JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME;

        const secondPartStartX = firstPartEndX

        return {
            x: parabolic(
                secondPartStartX,
                isLeftMovement ? secondPartStartX - distanceBetweenDots / 2 : secondPartStartX + distanceBetweenDots / 2,
                endXY.x,
                t,
            ),
            y: parabolic(
                startXY.y,
                startDot.dotY - distanseBetweenLayers,
                endXY.y,
                t,
            )
        };
    }
}